const erValidation = {
    decimal: function(value){
        return (value === '') || (!isNaN(parseFloat(value)) && isFinite(value));
    }
}

export default erValidation;



// WEBPACK FOOTER //
// ./src/lib/erValidation.js